<template>
  <div>
    <v-container class="py-10" id="cloud">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <div class="subtitle" style="color:#0391af">Chancen</div>
          <h2>37. Nutzung externer IT-Dienstleister 2020 vs. 2015</h2>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
          <v-btn icon aria-hidden="true">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" aria-hidden="true">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="download('image/jpeg')">
                <v-list-item-content>
                  <v-list-item-title>JPEG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download('image/svg+xml')">
                <v-list-item-content>
                  <v-list-item-title>SVG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            icon
            aria-hidden="true"
            :to="{
              name: 'comparison',
              query: { var: 'konkrete Herausforderungen' }
            }"
          >
            <v-icon>mdi-chart-line</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "A037",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Nutzt ihre Organisation externe IT-Dienstleister?​"
        },
        xAxis: {
          categories: ["2020", "2015"]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        colors: ["#444", "#005a85"],
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> <br />',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: "percent"
          }
        },
        series: [
          {
            name: "Nein",
            data: [42.9, 58]
          },
          {
            name: "Ja",
            data: [57.1, 40]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
